import React from 'react';

export interface TextArrowLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
}

export function TextArrowLink({ children, className = '', ...props }: TextArrowLinkProps) {
  const classes = `
    group inline-flex items-center gap-2
    text-body-sm text-foreground-muted/60 hover:text-foreground-secondary dark:hover:text-white/70
    transition-all duration-200
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <a {...props} className={classes}>
      <span>{children}</span>
      <span aria-hidden="true" className="transition-transform duration-200 group-hover:translate-x-1">
        →
      </span>
    </a>
  );
}

export default TextArrowLink;
